import { render, staticRenderFns } from "./chatGroupBox.vue?vue&type=template&id=50afbbb3&scoped=true&"
import script from "./chatGroupBox.vue?vue&type=script&lang=js&"
export * from "./chatGroupBox.vue?vue&type=script&lang=js&"
import style0 from "./chatGroupBox.vue?vue&type=style&index=0&id=50afbbb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50afbbb3",
  null
  
)

export default component.exports